import React, { useEffect, createElement } from 'react';
import { FarmingtonHillsHeroInfo } from './farmington-hills/FarmingtonHillsHeroInfo';
import { FarmingtonHillsHeroForm } from './farmington-hills/FarmingtonHillsHeroForm';
import { FarmingtonHillsDistance } from './farmington-hills/FarmingtonHillsDistance';
import { FarmingtonHillsWhy } from './farmington-hills/FarmingtonHillsWhy';
import { FarmingtonHillsPrograms } from './farmington-hills/FarmingtonHillsPrograms';
import { FarmingtonHillsScheduleLocation } from './farmington-hills/FarmingtonHillsScheduleLocation';
import { FarmingtonHillsReviews } from './farmington-hills/FarmingtonHillsReviews';
import { FarmingtonHillsFAQHeader } from './farmington-hills/FarmingtonHillsFAQHeader';
import { FarmingtonHillsFAQQuestions } from './farmington-hills/FarmingtonHillsFAQQuestions';
import { FarmingtonHillsLinks } from './farmington-hills/FarmingtonHillsLinks';
import { FarmingtonHillsFinalCTA } from './farmington-hills/FarmingtonHillsFinalCTA';
export function FarmingtonHills() {
  useEffect(() => {
    document.title = 'Taekwondo & Martial Arts Farmington Hills, MI | Storm';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Storm Taekwondo offers premium kids, adult, and family martial arts classes right here in Farmington Hills, MI. Claim your free one-week trial today.');
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = 'Storm Taekwondo offers premium kids, adult, and family martial arts classes right here in Farmington Hills, MI. Claim your free one-week trial today.';
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-1332">
      <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-1333">
        <div className="absolute inset-0 opacity-20" data-id="element-1334">
          <img src="https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=2000&q=80" alt="Taekwondo Background" className="block w-full h-full object-cover" data-id="element-1335" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-transparent" data-id="element-1336" />
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1337">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-1338">
            <FarmingtonHillsHeroInfo data-id="element-1339" />
            <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-1340">
              <FarmingtonHillsHeroForm data-id="element-1341" />
            </div>
          </div>
        </div>
      </section>

      <FarmingtonHillsDistance data-id="element-1342" />
      <FarmingtonHillsWhy data-id="element-1343" />
      <FarmingtonHillsPrograms data-id="element-1344" />
      <FarmingtonHillsScheduleLocation data-id="element-1345" />
      <FarmingtonHillsReviews data-id="element-1346" />
      <section className="py-24 bg-paper border-t border-subtle-gray" data-id="element-1347">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1348">
          <FarmingtonHillsFAQHeader data-id="element-1349" />
          <FarmingtonHillsFAQQuestions data-id="element-1350" />
        </div>
      </section>
      <FarmingtonHillsLinks data-id="element-1351" />
      <FarmingtonHillsFinalCTA data-id="element-1352" />
    </div>;
}